import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

function Navbar() {
  const { t, isArabic, toggleLanguage } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`top-nav ${scrolled ? 'top-nav-scrolled' : ''}`}>
      <div className="container nav-inner">
        <NavLink className="brand" to="/" onClick={() => setMobileOpen(false)}>
          <img
            className="brand-mark"
            src={`${process.env.PUBLIC_URL}/images/img.png`}
            alt=""
            width={32}
            height={32}
            decoding="async"
          />
          Real Estate Club
        </NavLink>
        <div className={`nav-links ${mobileOpen ? 'nav-links-open' : ''}`}>
          <NavLink to="/" end onClick={() => setMobileOpen(false)}>
            {t.nav.home}
          </NavLink>
          <NavLink to="/strategy" onClick={() => setMobileOpen(false)}>
            {t.nav.strategy}
          </NavLink>
          <NavLink to="/phase-one" onClick={() => setMobileOpen(false)}>
            {t.nav.phaseOne}
          </NavLink>
          <NavLink to="/investment" onClick={() => setMobileOpen(false)}>
            {t.nav.investment}
          </NavLink>
          <NavLink to="/services" onClick={() => setMobileOpen(false)}>
            {t.nav.services}
          </NavLink>
          <NavLink to="/audience" onClick={() => setMobileOpen(false)}>
            {t.nav.audience}
          </NavLink>
          <NavLink to="/marketing" onClick={() => setMobileOpen(false)}>
            {t.nav.marketing}
          </NavLink>
          <NavLink to="/media-initiative" onClick={() => setMobileOpen(false)}>
            {t.nav.mediaInitiative}
          </NavLink>
          <NavLink to="/sports-clubs" onClick={() => setMobileOpen(false)}>
            {t.nav.sportsClubs}
          </NavLink>
          <NavLink to="/visual-hub" onClick={() => setMobileOpen(false)}>
            {t.nav.visualHub}
          </NavLink>
          <NavLink to="/ideas" onClick={() => setMobileOpen(false)}>
            {t.nav.ideas}
          </NavLink>
          <NavLink to="/who-we-are" onClick={() => setMobileOpen(false)}>
            {t.nav.who}
          </NavLink>
          <NavLink to="/founder" onClick={() => setMobileOpen(false)}>
            {t.nav.founder}
          </NavLink>
          <NavLink to="/ai-assistant" className="nav-ai-link" onClick={() => setMobileOpen(false)}>
            <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14" aria-hidden="true">
              <path d="M14 2C14 2 15.8 9.2 22 14C15.8 18.8 14 26 14 26C14 26 12.2 18.8 6 14C12.2 9.2 14 2 14 2Z" fill="currentColor" />
            </svg>
            {t.nav.aiAssistant}
          </NavLink>
        </div>
        <div className="nav-actions">
          <button type="button" className="lang-btn" onClick={toggleLanguage} aria-label="Switch language">
            {isArabic ? 'English' : 'العربية'}
          </button>
          <NavLink className="primary-btn nav-cta" to="/audience">
            {t.nav.cta}
          </NavLink>
          <button
            type="button"
            className="menu-btn"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
